import { useParams, useHistory, Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import useHttp from "../../hooks/use-http";
import { endPoints } from "../../config/end-points";
import { projectActions } from "../../store/project-store";
import { authActions } from "../../store/auth";
import ReactPaginate from "react-paginate";
import cuteAlert, { cuteToast } from "../UI/cute";
import {
  FiEdit2, FiTrash2, FiEye, FiPlus, FiGlobe, FiLayers, FiSmartphone, FiLink,
  FiFolder, FiZap, FiSearch
} from "react-icons/fi";
import config, { getSubdomainUrl } from "../../config";
import AntiSpamModal from "../shared/modals/AntiSpamModal";
import "./ProjectList.css";

const ILLUST = `${process.env.PUBLIC_URL}/assets/images/niches`;

const nicheConfig = {
  restaurant: { gradient: "linear-gradient(135deg, #FFFFFF 0%, #FFFBEB 100%)", illust: `${ILLUST}/restaurant.svg`, accent: "#92400E", badgeBg: "#FEF3C7", badgeText: "#92400E" },
  travel:     { gradient: "linear-gradient(135deg, #FFFFFF 0%, #F0F9FF 100%)", illust: `${ILLUST}/travel.svg`, accent: "#0369A1", badgeBg: "#E0F2FE", badgeText: "#0369A1" },
  dental:     { gradient: "linear-gradient(135deg, #FFFFFF 0%, #ECFEFF 100%)", illust: `${ILLUST}/dental.svg`, accent: "#0E7490", badgeBg: "#CFFAFE", badgeText: "#0E7490" },
  medical:    { gradient: "linear-gradient(135deg, #FFFFFF 0%, #ECFDF5 100%)", illust: `${ILLUST}/medical.svg`, accent: "#047857", badgeBg: "#D1FAE5", badgeText: "#047857" },
  salon:      { gradient: "linear-gradient(135deg, #FFFFFF 0%, #FFF1F2 100%)", illust: `${ILLUST}/salon.svg`, accent: "#9D174D", badgeBg: "#FCE7F3", badgeText: "#9D174D" },
  gym:        { gradient: "linear-gradient(135deg, #FFFFFF 0%, #F7FEE7 100%)", illust: `${ILLUST}/gym.svg`, accent: "#3F6212", badgeBg: "#ECFCCB", badgeText: "#3F6212" },
  plumbing:   { gradient: "linear-gradient(135deg, #FFFFFF 0%, #EEF2FF 100%)", illust: `${ILLUST}/plumbing.svg`, accent: "#3730A3", badgeBg: "#E0E7FF", badgeText: "#3730A3" },
  roofing:    { gradient: "linear-gradient(135deg, #FFFFFF 0%, #FFF7ED 100%)", illust: `${ILLUST}/roofing.svg`, accent: "#9A3412", badgeBg: "#FFEDD5", badgeText: "#9A3412" },
  cleaning:   { gradient: "linear-gradient(135deg, #FFFFFF 0%, #F0F9FF 100%)", illust: `${ILLUST}/cleaning.svg`, accent: "#0284C7", badgeBg: "#E0F2FE", badgeText: "#0284C7" },
  automotive: { gradient: "linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)", illust: `${ILLUST}/automotive.svg`, accent: "#475569", badgeBg: "#F1F5F9", badgeText: "#475569" },
  legal:      { gradient: "linear-gradient(135deg, #FFFFFF 0%, #F5F3FF 100%)", illust: `${ILLUST}/legal.svg`, accent: "#5B21B6", badgeBg: "#EDE9FE", badgeText: "#5B21B6" },
  realestate: { gradient: "linear-gradient(135deg, #FFFFFF 0%, #ECFDF5 100%)", illust: `${ILLUST}/realestate.svg`, accent: "#065F46", badgeBg: "#D1FAE5", badgeText: "#065F46" },
  accounting: { gradient: "linear-gradient(135deg, #FFFFFF 0%, #EFF6FF 100%)", illust: `${ILLUST}/accounting.svg`, accent: "#1E40AF", badgeBg: "#DBEAFE", badgeText: "#1E40AF" },
  coaching:   { gradient: "linear-gradient(135deg, #FFFFFF 0%, #FAF5FF 100%)", illust: `${ILLUST}/coaching.svg`, accent: "#6D28D9", badgeBg: "#F5F3FF", badgeText: "#6D28D9" },
  saas:       { gradient: "linear-gradient(135deg, #FFFFFF 0%, #EEF2FF 100%)", illust: `${ILLUST}/saas.svg`, accent: "#4338CA", badgeBg: "#E0E7FF", badgeText: "#4338CA" },
  agency:     { gradient: "linear-gradient(135deg, #FFFFFF 0%, #FDF4FF 100%)", illust: `${ILLUST}/agency.svg`, accent: "#86198F", badgeBg: "#FAE8FF", badgeText: "#86198F" },
  photography:{ gradient: "linear-gradient(135deg, #FFFFFF 0%, #FFFBEB 100%)", illust: `${ILLUST}/photography.svg`, accent: "#A16207", badgeBg: "#FEF3C7", badgeText: "#A16207" },
  education:  { gradient: "linear-gradient(135deg, #FFFFFF 0%, #EFF6FF 100%)", illust: `${ILLUST}/education.svg`, accent: "#1D4ED8", badgeBg: "#DBEAFE", badgeText: "#1D4ED8" },
  nonprofit:  { gradient: "linear-gradient(135deg, #FFFFFF 0%, #ECFDF5 100%)", illust: `${ILLUST}/nonprofit.svg`, accent: "#047857", badgeBg: "#D1FAE5", badgeText: "#047857" },
  church:     { gradient: "linear-gradient(135deg, #FFFFFF 0%, #FAF5FF 100%)", illust: `${ILLUST}/church.svg`, accent: "#5B21B6", badgeBg: "#EDE9FE", badgeText: "#5B21B6" },
  ecommerce:  { gradient: "linear-gradient(135deg, #FFFFFF 0%, #FFF7ED 100%)", illust: `${ILLUST}/ecommerce.svg`, accent: "#C2410C", badgeBg: "#FFEDD5", badgeText: "#C2410C" },
  pet:        { gradient: "linear-gradient(135deg, #FFFFFF 0%, #FFF1F2 100%)", illust: `${ILLUST}/pet.svg`, accent: "#BE185D", badgeBg: "#FCE7F3", badgeText: "#BE185D" },
  events:     { gradient: "linear-gradient(135deg, #FFFFFF 0%, #FAF5FF 100%)", illust: `${ILLUST}/events.svg`, accent: "#7C3AED", badgeBg: "#F5F3FF", badgeText: "#7C3AED" },
  general:    { gradient: "linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)", illust: `${ILLUST}/general.svg`, accent: "#374151", badgeBg: "#F1F5F9", badgeText: "#374151" },
};

const statusConfig = {
  draft:     { bg: "#F3F4F6", text: "#6B7280" },
  wireframe: { bg: "#F5F3FF", text: "#7C3AED" },
  published: { bg: "#DCFCE7", text: "#166534" },
};

const ProjectList = () => {
  const { page_no } = useParams();
  const { sendRequest } = useHttp();
  const history = useHistory();
  const dispatch = useDispatch();

  const { projects, totalPages, totalCount, publishedCount } = useSelector((state) => state.project);
  const first_name = useSelector((state) => state.auth.first_name);
  const [load, setLoad] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [showTosModal, setShowTosModal] = useState(false);
  const tosChecked = useRef(false);

  useEffect(() => {
    document.title = `${endPoints.title} | Dashboard`;

    if (!tosChecked.current) {
      tosChecked.current = true;
      sendRequest(
        { url: endPoints.checkTos, method: "GET" },
        (response) => {
          if (response.status === 202) {
            setShowTosModal(true);
          }
        }
      );
    }
  }, []);

  useEffect(() => {
    const responseData = (response) => {
      if (response.status === 200) {
        dispatch(projectActions.setProjects({
          projects: response.content,
          totalPages: response.totalPages,
          totalCount: response.totalCount,
          publishedCount: response.publishedCount,
          currentPage: page_no ? parseInt(page_no) : 0
        }));
        dispatch(authActions.setLoaderStatus({ status: false }));
      } else {
        dispatch(authActions.setLoaderStatus({ status: false }));
      }
    };

    const page = page_no ? page_no : "";
    sendRequest({ url: endPoints.projectsList + "/" + page, method: "GET" }, responseData);
  }, [page_no, load, sendRequest, dispatch]);

  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredProjects(projects);
    } else {
      const filtered = projects.filter((project) =>
        project.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (project.niche && project.niche.toLowerCase().includes(searchTerm.toLowerCase()))
      );
      setFilteredProjects(filtered);
    }
  }, [searchTerm, projects]);

  const handlePageChange = ({ selected }) => {
    if (selected === 0) {
      history.push("/");
    } else {
      history.push("/builder/" + selected);
    }
  };

  const handleDeleteProject = (e, project_id, project_name) => {
    e.preventDefault();
    e.stopPropagation();

    cuteAlert({
      type: "question",
      title: "Delete Project?",
      message: `Are you sure you want to delete "${project_name}"? This action cannot be undone.`,
      confirmText: "Delete",
      cancelText: "Cancel",
    }).then((result) => {
      if (result === "confirm") {
        sendRequest(
          { url: endPoints.projects + "/delete", method: "POST", body: { project_id } },
          (response) => {
            if (response.status === 200) {
              dispatch(projectActions.removeProject(project_id));
              cuteToast({
                type: "success",
                title: "Project Deleted",
                message: "Project has been deleted successfully",
                timer: 3000,
              });
              setLoad(load + 1);
            }
          }
        );
      }
    });
  };

  const getNicheConfig = (niche) => {
    const key = niche?.toLowerCase() || "general";
    return nicheConfig[key] || nicheConfig.general;
  };

  const getStatusStyle = (status) => {
    return statusConfig[status] || statusConfig.draft;
  };

  const getEditRoute = (project) => {
    if (project.status === "draft") {
      return `/builder/sitemap/${project.id}`;
    }
    return `/builder/edit/${project.id}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <section className="mid_wrap pl-dashboard">
      <div className="container">
        {/* Hero Header */}
        <div className="pl-hero">
          <div className="pl-hero-inner">
            <div className="pl-hero-text">
              <h1 className="pl-greeting">
                {first_name ? `Welcome back, ${first_name}` : "Welcome back"}
                <span className="pl-greeting-wave">&#128075;</span>
              </h1>
              <p className="pl-subtitle">Create and manage your AI-powered websites</p>
            </div>

            <div className="pl-hero-right">
              <div className="pl-stats">
                <div className="pl-stat">
                  <div className="pl-stat-icon pl-stat-icon-total">
                    <FiFolder size={17} />
                  </div>
                  <div className="pl-stat-data">
                    <span className="pl-stat-number">{totalCount}</span>
                    <span className="pl-stat-label">Projects</span>
                  </div>
                </div>
                <div className="pl-stat">
                  <div className="pl-stat-icon pl-stat-icon-live">
                    <FiZap size={17} />
                  </div>
                  <div className="pl-stat-data">
                    <span className="pl-stat-number">{publishedCount}</span>
                    <span className="pl-stat-label">Published</span>
                  </div>
                </div>
              </div>

              <Link className="pl-new-project-btn" to="/builder/create">
                <FiPlus size={18} /> New Project
              </Link>
            </div>
          </div>
        </div>

        {/* Section Bar */}
        <div className="pl-section-bar">
          <h3 className="pl-section-title">
            Your Projects
            <span className="pl-section-count">{totalCount}</span>
          </h3>
          <div className="pl-search-wrapper">
            <FiSearch className="pl-search-icon" />
            <input
              type="text"
              className="pl-search-input"
              placeholder="Search projects..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* Projects Grid */}
        <div className="row">
          {filteredProjects.length > 0 ? (
            filteredProjects.map((project) => {
              const niche = getNicheConfig(project.niche);
              const statusStyle = getStatusStyle(project.status);

              return (
                <div className="col-xl-4 col-lg-6 col-md-6 pl-card-col" key={project.id}>
                  <div
                    className="pl-card"
                    style={{ background: niche.gradient }}
                    onClick={() => history.push(getEditRoute(project))}
                  >
                    {/* Niche illustration background */}
                    <img src={niche.illust} alt="" className="pl-niche-illust" />

                    {/* Status badge — top right */}
                    <span
                      className="pl-status-badge"
                      style={{ backgroundColor: statusStyle.bg, color: statusStyle.text }}
                    >
                      {project.status}
                    </span>

                    {/* Niche badge — top left */}
                    <span
                      className="pl-niche-badge"
                      style={{ backgroundColor: niche.badgeBg, color: niche.badgeText }}
                    >
                      {project.niche || "General"}
                    </span>

                    {/* Floating glass panel at bottom */}
                    <div className="pl-float-panel">
                      <div className="pl-float-top">
                        <h5 className="pl-project-name">{project.name}</h5>
                        <div className="pl-actions">
                          {project.status === "published" && project.subdomain && (
                            <>
                              <button
                                className="pl-action-btn pl-action-view"
                                title="View Live Site"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  window.open(getSubdomainUrl(project.subdomain), "_blank");
                                }}
                              >
                                <FiEye size={16} />
                              </button>
                              <button
                                className="pl-action-btn pl-action-app"
                                title="Generate Mobile App"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  history.push(`/builder/app-config/${project.id}`);
                                }}
                              >
                                <FiSmartphone size={16} />
                              </button>
                            </>
                          )}
                          <button
                            className="pl-action-btn pl-action-edit"
                            title="Edit"
                            onClick={(e) => {
                              e.stopPropagation();
                              history.push(getEditRoute(project));
                            }}
                          >
                            <FiEdit2 size={16} />
                          </button>
                          <button
                            className="pl-action-btn pl-action-delete"
                            title="Delete"
                            onClick={(e) => handleDeleteProject(e, project.id, project.name)}
                          >
                            <FiTrash2 size={16} />
                          </button>
                        </div>
                      </div>

                      <div className="pl-float-bottom">
                        <div className="pl-meta">
                          <span>{project.no_of_pages || 1} page{(project.no_of_pages || 1) !== 1 ? "s" : ""}</span>
                          <span className="pl-meta-dot" />
                          <span>{formatDate(project.updatedAt)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-12">
              <div className="pl-empty-state">
                <FiLayers size={52} className="pl-empty-icon" />
                <h5>{searchTerm ? "No projects found" : "No projects yet"}</h5>
                <p>{searchTerm ? "Try a different search term" : "Create your first AI-powered website in minutes"}</p>
                {!searchTerm && (
                  <Link to="/builder/create" className="pl-new-project-btn">
                    <FiPlus size={18} />
                    Create Your First Project
                  </Link>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <nav aria-label="Pagination" className="pl-pagination">
            <ReactPaginate
              previousLabel={"<"}
              nextLabel={">"}
              breakLabel="..."
              breakClassName={"pl-pg-break"}
              breakLinkClassName={"pl-pg-link"}
              pageCount={totalPages}
              onPageChange={handlePageChange}
              containerClassName={"pl-pg-container"}
              pageClassName={"pl-pg-item"}
              pageLinkClassName={"pl-pg-link"}
              activeClassName={"pl-pg-active"}
              previousClassName={"pl-pg-item pl-pg-prev"}
              nextClassName={"pl-pg-item pl-pg-next"}
              previousLinkClassName={"pl-pg-link"}
              nextLinkClassName={"pl-pg-link"}
              disabledClassName={"pl-pg-disabled"}
              initialPage={page_no ? parseInt(page_no) : 0}
            />
          </nav>
        )}
      </div>

      {showTosModal && <AntiSpamModal onClose={() => setShowTosModal(false)} />}
    </section>
  );
};

export default ProjectList;
